import { render, staticRenderFns } from "./MobileSettings.vue?vue&type=template&id=4ecd1906&scoped=true"
import script from "./MobileSettings.vue?vue&type=script&lang=js"
export * from "./MobileSettings.vue?vue&type=script&lang=js"
import style0 from "./MobileSettings.vue?vue&type=style&index=0&id=4ecd1906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecd1906",
  null
  
)

export default component.exports